// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  fromPublicId: __t.u32(),
  tx: __t.u32(),
  tz: __t.u32(),
  mode: __t.string(),
  textureIndex: __t.u32(),
  heightStep: __t.f64(),
  brushRadius: __t.u32(),
});
